export const EstadoPolizaAfiliacion = [
    {
        nombre: "ACTIVA",
        tipo: "ACTIVA"
    },
    {
        nombre: "NO APLICA",
        tipo: "NO_APLICA"
    }
];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/EstadoPolizaAfiliacion.ts